import React, { Component } from 'react';

class RadioButtonGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValue: props.prevSelectedValue || ''
            
        };
    }

    handleSelectedValueChange = event => {
      //  console.log("Value: " + this.state.selectedValue)
        const { value } = event.target;
        this.setState({
            selectedValue: value
        });
        //console.log("State of Value: " + value);
        this.props.onSelectedValueChange(value, true);
    }
        
    render() {
        // eslint-disable-next-line
        const { labels, values, prevSelectedValue, currentIndex, onSelectedValueChange } = this.props;
        // eslint-disable-next-line
        const selectedValue = this.state.selectedValue;
        const previousSelectedValue = prevSelectedValue;
        return (
            <div className="roomForAnswers" id={currentIndex}>
                {labels.map((label, index) => (
                    <div className="radio_buttons" key={index}>
                        <label className='bubbleLabel'>
                            
                        <input
                                id={"radio_" + currentIndex + '_' + values[index]} 
                                type="radio"
                                className='radio_button'
                                value={values[index]}
                                checked={previousSelectedValue === values[index]}
                                onChange={this.handleSelectedValueChange} 
                            />
                            {label}
                        </label>
                    </div>
                ))}
            </div>
        );
    }
}

export default RadioButtonGroup;
